/**
 * SAARTHI brand mark.
 *
 * Variants:
 *   <Brand />           — default (icon + wordmark + tagline)
 *   <Brand size="sm" /> — sidebar-friendly compact mark
 *   <Brand size="lg" /> — login/home hero mark
 */
export default function Brand({ size = "md", className = "" }) {
  const isLarge = size === "lg";
  const isSmall = size === "sm";

  return (
    <div
      className={`flex items-center gap-2 ${className}`}
      data-testid="saarthi-brand"
    >
      <div
        className={`relative inline-flex items-center justify-center rounded-md bg-indigo-700 text-white shrink-0 ${
          isLarge ? "w-10 h-10" : isSmall ? "w-7 h-7" : "w-8 h-8"
        }`}
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          className={isLarge ? "w-6 h-6" : "w-4 h-4"}
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 18 L12 4 L21 18" />
          <path d="M8 18 L12 12 L16 18" />
        </svg>
      </div>
      <div className="leading-tight">
        <div
          className={`font-semibold tracking-tight text-slate-900 ${
            isLarge ? "text-xl" : isSmall ? "text-sm" : "text-base"
          }`}
        >
          SAARTHI
        </div>
        {!isSmall ? (
          <div
            className={`text-slate-500 ${
              isLarge ? "text-xs" : "text-[10px]"
            } uppercase tracking-[0.18em]`}
          >
            Mind Mantra
          </div>
        ) : null}
      </div>
    </div>
  );
}
